import React, { createContext, useContext } from 'react';
import { useMachineDetailsRobotScheduleState } from '../hooks/useMachineDetailsRobotSchedule';
import type {
  MachineDetailsRobotScheduleContextValue,
  UseMachineDetailsRobotScheduleStateParams,
} from '../types/MachineDetailsRobotSchedule.types';

const MachineDetailsRobotScheduleContext = createContext<MachineDetailsRobotScheduleContextValue | null>(null);

export const MachineDetailsRobotScheduleProvider = ({
  robot,
  children,
}: React.PropsWithChildren<UseMachineDetailsRobotScheduleStateParams>): React.JSX.Element => {
  const value = useMachineDetailsRobotScheduleState({ robot });

  return (
    <MachineDetailsRobotScheduleContext.Provider value={value}>{children}</MachineDetailsRobotScheduleContext.Provider>
  );
};

export const useMachineDetailsRobotScheduleContext = (): MachineDetailsRobotScheduleContextValue => {
  const context = useContext(MachineDetailsRobotScheduleContext);

  if (!context) {
    throw new Error('useMachineDetailsRobotScheduleContext must be used within MachineDetailsRobotScheduleProvider');
  }

  return context;
};

export const useMachineDetailsRobotSchedule = (): MachineDetailsRobotScheduleContextValue =>
  useMachineDetailsRobotScheduleContext();
